import { render, staticRenderFns } from "./ModalBody.vue?vue&type=template&id=01572280&scoped=true"
import script from "./ModalBody.vue?vue&type=script&lang=js"
export * from "./ModalBody.vue?vue&type=script&lang=js"
import style0 from "./ModalBody.vue?vue&type=style&index=0&id=01572280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01572280",
  null
  
)

export default component.exports